import React from 'react';
import { FacebookIcon, InstagramIcon, TwitterIcon, MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#2D2D2D] text-white" data-id="element-34">
      <div className="max-w-7xl mx-auto px-6 py-20" data-id="element-35">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 lg:gap-24" data-id="element-36">
          {/* Logo & Description */}
          <div className="space-y-8" data-id="element-37">
            <div className="flex flex-col" data-id="element-38">
              <span className="text-4xl font-black text-white leading-none tracking-tighter" data-id="element-39">
                NK Resurfacers
              </span>
            </div>
            <p className="text-white/80 leading-relaxed text-sm" data-id="element-40">
              NK Resurfacers offers a wide variety of brand name cabinetry and
              flooring to meet both residential and commercial needs, from
              classic and elegant to sleek and contemporary.
            </p>
          </div>

          {/* Subscribe Now */}
          <div className="space-y-8" data-id="element-41">
            <h4 className="text-xl font-bold" data-id="element-42">Subscribe Now</h4>
            <div className="space-y-4" data-id="element-43">
              <input type="text" placeholder="Enter Your Name" className="w-full bg-white text-charcoal px-4 py-3 text-sm italic outline-none" data-id="element-44" />
              <input type="email" placeholder="Enter Your Email" className="w-full bg-white text-charcoal px-4 py-3 text-sm italic outline-none" data-id="element-45" />
              <button className="bg-[#6B0D24] hover:bg-[#5A0B1E] text-white px-8 py-3 font-bold transition-colors" data-id="element-46">
                Subscribe
              </button>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-8" data-id="element-47">
            <h4 className="text-xl font-bold" data-id="element-48">Contact Info</h4>
            <ul className="space-y-4 text-white/80" data-id="element-49">
              <li className="flex items-center gap-3" data-id="element-50">
                <PhoneIcon className="w-4 h-4" data-id="element-51" />
                <a href="tel:4107776984" className="hover:text-white transition-colors" data-id="element-52">
                  410-777-6984
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-53">
                <MailIcon className="w-4 h-4" data-id="element-54" />
                <a href="mailto:nkrefacers@gmail.com" className="hover:text-white transition-colors" data-id="element-55">
                  nkrefacers@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-56">
                <MapPinIcon className="w-4 h-4" data-id="element-57" />
                <span data-id="element-58">12810 7 st Bowie MD 20720</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="bg-[#252525] py-6 px-6 border-t border-white/5" data-id="element-59">
        <div className="max-w-7xl mx-auto text-center text-sm text-white/60" data-id="element-60">
          <p data-id="element-61">
            © 2018-2026{' '}
            <span className="font-bold text-white" data-id="element-62">NK Resurfacers LLC</span> All
            Rights Reserved.
          </p>
        </div>
      </div>
    </footer>;
}